import React, {useState} from 'react';
import {StreamBankAutoCompleteHeaderItem} from "../../Models/Extensions/Core/StreamBankAutoCompleteHeaderItem";
import {useBuildContextNodeEditabilityElement} from "../../Hooks/GenericModelHooks";
import {service as ContextNodeService} from "../../Services/ContextNodeService";
import {service as ContextNodeTypeService} from "../../Services/ContextNodeTypeService";
import {
    ServiceDrivenAutoCompleteFieldEditor
} from "../../Models/Core/FieldEditors/ServiceDrivenAutoCompleteFieldEditor";
import {usePrimeCache} from "../../Hooks/ServiceHooks";


const _ContextNodeFieldEditor = ServiceDrivenAutoCompleteFieldEditor(ContextNodeService);
export const ContextNodeAutoSelect = props => {
    
    usePrimeCache([ContextNodeTypeService]);

    const {OnUpdateModel, OnUpdate } = props;
    const {
        contextNodeTypeId = null,
        userRoleId = null,
        placeholder = null,
    } = props;
    
    const [contextNode, setContextNode] = useState(null);

    // filters out invalid organizationId nodes
    // as well as 
    const valuesFilter = (values) => {
        if (props.OrganizationId) {
            values = values.filter((x) => Number(x.organizationId) === Number(props.OrganizationId));
        }
        
        if (contextNodeTypeId) {
            values = values.filter((x) => Number(x.contextNodeTypeId) === Number(contextNodeTypeId));
        }

        const headers = values.reduce((headers, value) =>
                headers[value.contextDescription] ??=
                    <StreamBankAutoCompleteHeaderItem>{value.contextDescription}</StreamBankAutoCompleteHeaderItem>
            , {});
        return values.concat(Object.values(headers));
    };

    const buildContextNodeEditabilityElement = useBuildContextNodeEditabilityElement();
    let editability = buildContextNodeEditabilityElement(contextNode, userRoleId);

    const onUpdateModel = (contextNode) => {
        setContextNode(contextNode)
        OnUpdateModel?.(contextNode);
    }
    
    const contextNodeTypeTitle = contextNodeTypeId ? ContextNodeTypeService.CachedTitleById(contextNodeTypeId) : null;

    // TODO: fix onUpdate not actually selecting the value
    return <_ContextNodeFieldEditor
        {...props}
        OnUpdate={OnUpdate}
        OnUpdateModel={onUpdateModel}
        ValuesFilter={valuesFilter}
        children={editability}
        additionalSearchParams={{contextNodeTypeId}}
        placeholder={placeholder ?? contextNodeTypeTitle}
    />;
};

